import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-live-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold">最新电视剧</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              我们专注为追剧爱好者整理当下最热门的电视剧推荐、详细剧情介绍与播出信息，
              帮助你第一时间掌握最新剧集动态，不错过每一部好剧。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-youtube-fill', 'ri-instagram-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950 cursor-pointer"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#footer-nav" className="hover:text-accent-400">剧集分类</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-2.5 text-sm text-background-300">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="transition-colors hover:text-accent-400">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#footer-links" className="hover:text-accent-400">快捷导航</a>
            </h4>
            <ul id="footer-links" className="mt-4 space-y-2.5 text-sm text-background-300">
              <li><Link to="/" className="transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/search" className="transition-colors hover:text-accent-400">搜索剧集</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-400">关于我们</Link></li>
              <li><Link to="/about#contact" className="transition-colors hover:text-accent-400">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 最新电视剧 · 本站剧集资料均为虚构示例，仅用于内容展示。</p>
          <p className="flex flex-wrap gap-4">
            <span className="whitespace-nowrap">隐私政策</span>
            <span className="whitespace-nowrap">服务条款</span>
            <span className="whitespace-nowrap">友情链接</span>
          </p>
        </div>
      </div>
    </footer>
  );
}